import { BrowserRouter } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { NotificationProvider } from './contexts/NotificationContext';
import AppRoutes from './Routes';
import CompanyMessages from './components/company/CompanyMessages';
import './App.css';
import './i18n/config';
import { initSentry } from './services/sentry';
import i18n from './i18n/config';
import { LiveEditorProvider } from './contexts/LiveEditorContext';

// Initialize Sentry
initSentry();

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <DataProvider>
          <AuthProvider>
            <PermissionsProvider>
              <NotificationProvider>
                <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={i18n.language}>
                  <CompanyMessages />
                  <LiveEditorProvider>
                    <AppRoutes />
                  </LiveEditorProvider>
                </LocalizationProvider>
              </NotificationProvider>
            </PermissionsProvider>
          </AuthProvider>
        </DataProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
